import { render, staticRenderFns } from "./HonorariosProtesto.vue?vue&type=template&id=3c5f3369&"
import script from "./HonorariosProtesto.vue?vue&type=script&lang=js&"
export * from "./HonorariosProtesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports